export function useSleep(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}
